import {
  fetchAccountStateSample,
  fetchFinderResult,
} from "./testAccountHealth/fetchAccountStateSample"
import { evaluateHealth } from "@/models/admin/testAccountHealth/evaluateHealth"
import {
  AccountHealthRow,
  AccountStateSample,
  TestAccountMapEntry,
} from "@/models/admin/testAccountHealth/testAccountHealth.types"

class TestAccountHealthServiceClass {
  async probeAccount(
    entry: TestAccountMapEntry,
    sampleCount = 2,
  ): Promise<AccountHealthRow> {
    const rows = await this.probeAll([entry], sampleCount)
    return rows[0]
  }

  async probeAll(
    entries: TestAccountMapEntry[],
    sampleCount = 2,
  ): Promise<AccountHealthRow[]> {
    const samplesByEntry: AccountStateSample[][] = entries.map(() => [])

    for (let round = 0; round < sampleCount; round++) {
      // One finder query per round shared by every account - it returns the
      // full test-account list, so per-account fetches were pure duplication.
      const finderPromise = fetchFinderResult()
      const roundSamples = await Promise.all(
        entries.map((entry) =>
          fetchAccountStateSample(entry.accountNumber, finderPromise),
        ),
      )
      roundSamples.forEach((roundSample, index) =>
        samplesByEntry[index].push(roundSample),
      )
    }

    return entries.map((entry, index) => ({
      entry,
      samples: samplesByEntry[index],
      health: evaluateHealth(entry.expected, samplesByEntry[index]),
    }))
  }
}

export const TestAccountHealthService = new TestAccountHealthServiceClass()
